function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useCallback } from "react";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import TextField from "@mui/material/TextField";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import styled from "styled-components";
const StyledTextField = styled(TextField)`
  && {
    width: 100%;
    font-weight: ${p => p.theme.inputFontWeight};
    font-size: 1rem;
    font-family: ${props => props.theme.inputFontFamily};
    border-bottom: 2px solid #e7e7e7;
    border-radius: 0.25rem;
    border: 2px solid #e7e7e7;
    background: transparent;
    opacity: 1;
  }

  & input {
    border: none;
    font-family: ${props => props.theme.inputFontFamily};
    font-weight: ${p => p.theme.inputFontWeight};
    font-size: 1rem;
    font-style: normal;
    margin-top: 10px;
  }

  & fieldset {
    border: none;
  }

  & label {
    top: 1rem;
    color: ${p => p.theme.colorLabel};
    font-family: inherit;
  }

  & button {
    margin-top: 8px;
  }
`;
const StyledDatePicker = styled(DatePicker)`
  && .MuiCalendarPicker-root {
    font-family: ${props => props.theme.inputFontFamily};
    font-size: 1rem;
    font-style: normal;
  }

  && .MuiCalendarPicker-root.Mui-selected .Mui-selected {
    background-color: ${props => props.theme.colorAccent};
  }
`;

const NewDatePicker = ({
  dateInputFormat,
  values,
  errors,
  handleBlur,
  setFieldTouched,
  setFieldValue,
  translations
}) => {
  const [dateOfBirth, setDateOfBirth] = useState(new Date());
  const [open, setOpen] = useState(false);
  const handleDOB = useCallback(dob => {
    let convertedDate = moment(dob, "D MMM YYYY").format(dateInputFormat);
    setDateOfBirth(dob); // console.log("This be the test " + convertedDate)
    // console.log("Moment" + dob)
    // console.log("Date of Birth Values " + values.birthDate)

    setFieldValue("birthDate", convertedDate);
    setFieldTouched("birthDate", true, true);
  }, [dateInputFormat, setDateOfBirth, setFieldTouched, setFieldValue]);
  useEffect(() => {
    if (values.birthDate !== "") {
      let convertedDate = moment(values.birthDate, dateInputFormat);
      handleDOB(convertedDate);
    }
  }, [values, handleDOB, dateInputFormat]);
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: MomentUtils
  }, /*#__PURE__*/React.createElement(StyledDatePicker, {
    open: open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
    name: "birthDate",
    label: "Date of Birth",
    isRequired: true,
    isError: values.birthDate !== "" && errors.birthDate,
    disableFuture: true,
    openTo: "year",
    views: ["year", "month", "day"],
    value: dateOfBirth,
    onChange: newValue => {
      handleDOB(newValue);
    },
    renderInput: params => {
      return /*#__PURE__*/React.createElement(StyledTextField, _extends({}, params, {
        inputProps: { ...params.inputProps,
          placeholder: translations.birthDate
        },
        onClick: e => setOpen(true),
        onKeyDown: e => e.preventDefault()
      }));
    },
    onBlur: handleBlur,
    inputFormat: "MMM D YYYY",
    disableMaskedInput: true
  }));
};

export default NewDatePicker;